export default {
  'menu.home': '首页',
  'menu.login': '登录',
  'menu.logout': '退出登录',
  'menu.dashboard': 'Dashboard',
  'menu.welcome': '欢迎',
  'menu.merchant': '商户管理',
  'menu.developer': '开发者设置',
  'menu.merchant.center': '商户中心',
  'menu.merchant.settings': '商户设置',
  'menu.merchant.walletaddress': '钱包地址',
  'menu.orderin': '代收订单',
  'menu.orderout': '代付订单',
  'menu.order.export': '订单导出',
  'menu.asset': '资产管理',
  'menu.asset.cash': '资产提现',
  'menu.asset.logs': '资产流水',

  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',

  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',

};
